import { computed as e, ref as t } from "vue";
const a = 12, o = Object.freeze({
  key: Symbol("DATA_VIEW_INJECTION_KEY"),
  defaults: Object.freeze({
    // Pagination
    currentPage: e(() => 1),
    isPaginateNextDisabled: e(() => !1),
    isPaginationEnabled: e(() => !1),
    pageCount: e(() => 1),
    pageSize: e(() => a),
    totalDataCount: e(() => 0),
    setPage() {
    },
    goPrevPage() {
    },
    goNextPage() {
    },
    // Sorting
    currentSortId: e(() => {
    }),
    currentSortOrder: e(() => {
    }),
    updateCurrentSort() {
    },
    // Search
    currentSearch: e(() => ""),
    updateCurrentSearch() {
    },
    // Miscellanous
    density: e(() => {
    }),
    isEmpty: e(() => !1),
    isLoading: e(() => !1),
    isSelectable: t(!1),
    isWithinModule: e(() => !1),
    variant: e(() => {
    })
  })
});
export {
  o as D,
  a
};
//# sourceMappingURL=DataView.keys-aSOnA4AD.js.map
